// extracted by mini-css-extract-plugin
export default {"orderList":"OrdersFeed_orderList__NMTV6","orderProfileList":"OrdersFeed_orderProfileList__IXb70 OrdersFeed_orderList__NMTV6"};